<div class="container mt-4" dir="rtl">
  <h3>سایت‌ها</h3>

  <!-- بخش جستجو و دکمه افزودن -->
  <div class="d-flex justify-content-between align-items-center mb-3">
    <!-- فیلد جستجو -->
    <div class="flex-grow-1 me-3">
      <input
        type="text"
        class="form-control"
        placeholder="جستجو بر اساس آدرس یا متن..."
        [(ngModel)]="searchTerm"
        (input)="onSearchInput()"
        aria-label="جستجو در سایت‌ها">
    </div>
    <!-- Add user Button -->
    <div>
      <button class="btn btn-primary" (click)="openModal()">
        افزودن سایت جدید
      </button>
    </div>
  </div>

  <!-- 🟪 نسخه موبایل: نمایش کارتی -->
  <div class="d-block d-md-none">
    <!-- ❗ اگر ngOnInit فراخوانی نشود، این لیست در ابتدا خالی خواهد بود -->
    <div *ngFor="let item of filteredList" class="card mb-3 shadow-sm">
      <div class="card-body">
        <h5 class="card-title fw-bold">{{ item.wbeAddress }}</h5>
        <!-- ❗ اصلاح: نمایش متن سایت به جای تکرار آدرس -->
        <p class="card-text">{{ item.text }}</p>
        <div class="mt-2 text-end">
          <button class="btn btn-warning btn-sm me-2" (click)="openEditModal(item)">ویرایش</button>
          <button class="btn btn-danger btn-sm" (click)="delete(item.id)">حذف</button>
        </div>
      </div>
    </div>

    <!-- پیام در صورت عدم وجود نتایج در موبایل -->
    <div *ngIf="filteredList.length === 0" class="alert alert-info text-center" role="alert">
      نتیجه‌ای یافت نشد.
    </div>
  </div>

  <!-- 🟪 نسخه دسکتاپ: نمایش جدولی -->
  <div class="table-responsive d-none d-md-block">
    <table class="table table-bordered text-end custom-table">
      <thead class="custom-thead">
        <tr>
          <th style="width: 40%;">آدرس سایت</th>
          <th>متن</th>
          <!-- ❗ اصلاح: اضافه شدن عنوان برای ستون عملیات -->
          <th style="width: 30%; white-space: nowrap;">عملیات</th>
        </tr>
      </thead>
      <tbody>
        <!-- ❗ اگر ngOnInit فراخوانی نشود، این لیست در ابتدا خالی خواهد بود -->
        <tr *ngFor="let item of filteredList">
          <!-- ❗ اصلاح: dir="ltr" مستقیماً روی td اعمال شده، div اضافی حذف شده -->
          <td dir="ltr">
            <a [href]="fixUrl(item.wbeAddress)" target="_blank" rel="noopener noreferrer" style="cursor:pointer; text-decoration: none;">
              {{ item.wbeAddress }}
            </a>
          </td>
          <td>{{ item.text }}</td>
          <td>
            <button class="btn btn-warning btn-sm me-2" (click)="openEditModal(item)">ویرایش</button>
            <button class="btn btn-danger btn-sm" (click)="delete(item.id)">حذف</button>
          </td>
        </tr>

        <!-- پیام در صورت عدم وجود نتایج در دسکتاپ -->
        <tr *ngIf="filteredList.length === 0">
          <td colspan="3" class="text-center alert alert-info" role="alert">
            نتیجه‌ای یافت نشد.
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Modal -->
  <div class="modal fade" #userModal id="userModal" tabindex="-1" aria-labelledby="userModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content" dir="rtl">
        <div class="modal-header">
          <h5 class="modal-title" id="userModalLabel">
            {{ anyObj.id ? 'ویرایش سایت' : 'افزودن سایت' }}
          </h5>
          <!-- ❗ اصلاح: فراخوانی closeModal() هنگام بستن -->
          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModal()" aria-label="بستن"></button>
        </div>

        <div class="modal-body">
          <form id="userForm">
            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label">آدرس سایت</label>
                <input type="text" [(ngModel)]="anyObj.wbeAddress" name="wbeAddress" class="form-control" placeholder="آدرس سایت (مثال: example.com)">
              </div>

              <div class="col-md-6">
                <label class="form-label">توضیحات سایت</label>
                <input type="text" [(ngModel)]="anyObj.text" name="text" class="form-control" placeholder="متن یا توضیحات سایت">
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <!-- ❗ اصلاح: فراخوانی closeModal() هنگام بستن -->
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="closeModal()">بستن</button>
          <button type="button" (click)="onSave()" class="btn btn-success">
            {{ anyObj.id ? 'ذخیره تغییرات' : 'افزودن' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
